var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-bg-canvas-player__container"})
}
var staticRenderFns = []

export { render, staticRenderFns }